/**
 * Grundbuchmeldung API
 * API for Grundbuchmeldung Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MeldungsEmpfaengerSearchRequest { 
    bezeichnung?: string;
    sedexId?: string;
    erhaeltMeldungen?: boolean;
    erhaeltVertraulicheDaten?: boolean;
    erhaeltBasedelivery?: boolean;
    meldungsEmpfaengerSort?: MeldungsEmpfaengerSearchRequest.MeldungsEmpfaengerSortEnum;
    sortDirection?: MeldungsEmpfaengerSearchRequest.SortDirectionEnum;
    offset?: number;
    limit?: number;
    searchQuery?: string;
}
export namespace MeldungsEmpfaengerSearchRequest {
    export type MeldungsEmpfaengerSortEnum = 'BEZEICHNUNG' | 'SEDEX_ID' | 'ERHAELTMELDUNGEN' | 'ERHAELTVERTRAULICHEDATEN' | 'ERHAELTBASEDELIVERY';
    export const MeldungsEmpfaengerSortEnum = {
        BEZEICHNUNG: 'BEZEICHNUNG' as MeldungsEmpfaengerSortEnum,
        SEDEXID: 'SEDEX_ID' as MeldungsEmpfaengerSortEnum,
        ERHAELTMELDUNGEN: 'ERHAELTMELDUNGEN' as MeldungsEmpfaengerSortEnum,
        ERHAELTVERTRAULICHEDATEN: 'ERHAELTVERTRAULICHEDATEN' as MeldungsEmpfaengerSortEnum,
        ERHAELTBASEDELIVERY: 'ERHAELTBASEDELIVERY' as MeldungsEmpfaengerSortEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
}


